<!--footer-->
<!--<div class="banner-footer"></div>-->

<div class="ramadan20-footer">
  <a href="https://www.gbarena.com" target="_blank" class="gbarena">
    <img src="assets/img/GBarena-type.svg" style="width: 80px" alt="GBarena Logo">
    <img src="assets/img/ramadan20/ramadan-logo.svg" style="width: 140px; margin:0 10px;" alt="GBarena Logo">

  </a>
  <p>Ramadan20 event is hosted and powered by GBarena
    <br>
    <a href=""></a>All Terms & Conditions Apply</p>
  <span>
        <a href="mailto:mail@gbarena.com" target="_blank"><i class="icon-mail"></i></a>
    <a href="https://facebook.com/gbarena" target="_blank"><i class="icon-facebook-circled"></i></a>
    <a href="https://twitter.com/gbarenaofficial" target="_blank"><i class="icon-twitter-circled"></i></a>
    <a href="https://www.instagram.com/gbarenaofficial" target="_blank"><i  class="icon-instagram-circled"></i></a>
    <a href="https://discord.gg/4r43M4r" target="_blank">
      <img src="assets/img/icons/discord-logo-white.svg" width="15" style="margin: 0 5px 5px 5px;" alt="">
    </a>
  </span>
</div>